export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  viewCount: number;
  tags: string[];
  isHot: boolean;
  isTrending: boolean;
}

export const categories: { name: string; slug: string; description: string; icon: string }[] = [
  { name: '网红黑料', slug: 'wanghong-heiliao', description: '网红圈最新黑料、私生活曝光、翻车事件全收录', icon: 'ri-user-search-line' },
  { name: '明星塌房', slug: 'mingxing-tafang', description: '明星艺人塌房事件第一手报道，深度扒皮娱乐圈', icon: 'ri-star-line' },
  { name: '热门爆料', slug: 'remen-baoliao', description: '全网最火爆料帖汇总，吃瓜群众必看', icon: 'ri-fire-line' },
  { name: '实时追踪', slug: 'shishi-zhuizong', description: '24小时不间断追踪最新大瓜，不错过任何一个瓜', icon: 'ri-radar-line' },
  { name: '社会大瓜', slug: 'shehui-dagua', description: '社会热点事件深度解读，大瓜不断', icon: 'ri-earth-line' },
  { name: '综艺翻车', slug: 'zongyi-fanche', description: '综艺节目翻车名场面、选手黑历史大起底', icon: 'ri-tv-line' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时，粉丝集体脱粉',
    excerpt: '据知情人士爆料，近日某顶流男星在结束活动后，深夜独自前往某五星级酒店，与一神秘女子密会长达8小时。消息一出，粉丝后援会集体宣布脱粉，工作室至今未作回应。',
    content: '<p>据知情人士爆料，近日某顶流男星在结束某商业活动后，深夜独自驱车前往位于市中心的某五星级酒店。据酒店监控显示，该男星于当晚11点30分左右进入酒店大堂，随后一名身着黑色风衣的神秘女子也出现在酒店，两人一前一后进入电梯。</p><p>据酒店工作人员透露，两人在酒店房间内共度了约8个小时，直到次日早上7点左右才先后离开。该神秘女子离开时戴着口罩和墨镜，刻意遮挡面容，但身材高挑、气质出众。</p><p>消息在网络上传开后，该男星的多个粉丝后援会集体发表声明宣布脱粉。有粉丝在社交平台发文称："我们花钱应援，没想到你却在背后做这种事。"截至发稿前，该男星工作室仍未对此次事件作出任何回应，其社交媒体账号也处于停更状态。</p><p>业内人士分析认为，此次事件对该男星的商业价值和公众形象将造成重大打击。据不完全统计，已有至少三个品牌方紧急暂停了与该男星的合作。</p><p>我们将持续关注此事的后续发展，第一时间为大家带来最新消息。</p>',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20moody%20hotel%20corridor%20at%20night%20with%20dim%20golden%20lighting%2C%20luxury%20atmosphere%2C%20mysterious%20silhouette%20walking%20away%2C%20cinematic%20mood%2C%20dramatic%20shadows%2C%20editorial%20photography%20style%2C%20warm%20dark%20tones%2C%20no%20text%2C%20clean%20composition%2C%20minimalist&width=800&height=500&seq=article-cover-001&orientation=landscape',
    author: '吃瓜小分队',
    publishDate: '2026-07-07',
    viewCount: 1285000,
    tags: ['顶流男星', '密会', '脱粉', '酒店', '塌房'],
    isHot: true,
    isTrending: true,
  },
  {
    id: 'article-2',
    title: '知名网红直播带货翻车，假货被当场揭穿，直播间被封禁',
    excerpt: '拥有千万粉丝的知名带货网红在昨晚直播中，被职业打假人当场揭穿售卖假冒化妆品。品牌方紧急发声明撇清关系，平台已对该账号进行永久封禁处理。',
    content: '<p>昨晚8点，拥有超过1200万粉丝的知名带货网红"XX美妆达人"在直播中推销一款声称"专柜正品"的高端护肤品时，被潜伏在直播间的职业打假人当场揭穿。</p><p>该打假人通过连线功能直接指出，该网红售卖的护肤品包装上的防伪码与官方查询结果不符，且产品的质地、气味与正品存在明显差异。面对突如其来的质疑，该网红当场语塞，随后匆忙结束了直播。</p><p>事件发酵后，品牌方连夜发布声明，明确表示与该网红不存在任何合作关系，并保留追究其法律责任的权利。直播平台也迅速作出反应，于今日凌晨对该账号进行永久封禁处理。</p><p>据业内人士透露，该网红此前已多次被举报售卖假货，但均通过各种方式逃避了处罚。此次事件的曝光，也引发了公众对直播带货行业监管的广泛讨论。</p><p>多位消费者表示将通过法律途径维权，要求该网红退一赔三。我们将持续关注此事的后续进展。</p>',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20livestream%20studio%20scene%20with%20red%20alert%20vibe%2C%20ring%20light%20casting%20harsh%20shadows%2C%20cosmetics%20scattered%20on%20table%2C%20tense%20atmosphere%2C%20warm%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20mood%2C%20no%20text%2C%20clean%20minimalist%20background&width=800&height=500&seq=article-cover-002&orientation=landscape',
    author: '真相挖掘机',
    publishDate: '2026-07-06',
    viewCount: 986000,
    tags: ['直播带货', '假货', '翻车', '封号', '打假'],
    isHot: true,
    isTrending: true,
  },
  {
    id: 'article-3',
    title: '某综艺节目导演组内讧曝光，恶意剪辑艺人镜头引众怒',
    excerpt: '一段疑似综艺节目导演组内部聊天记录在网上疯传，内容涉及恶意剪辑某艺人镜头以制造话题。消息曝光后，多位艺人发声明谴责，节目组紧急道歉。',
    content: '<p>昨日深夜，一段疑似某热门综艺节目导演组内部微信群聊的截图在社交平台疯传。聊天记录显示，导演组成员在讨论如何通过恶意剪辑来制造某艺人的"黑点"，以达到提高节目话题度的目的。</p><p>聊天记录中，一名疑似执行导演的人士直言："把他表现不好的片段全部放大，好的部分全部删掉，让观众觉得他就是个拖后腿的。"另一名工作人员则回应："这样会不会太明显了？"该执行导演回复："观众又不知道真相，我们怎么剪他们就怎么看。"</p><p>该聊天记录曝光后，引发业界强烈震动。多位曾参与该节目的艺人纷纷发声明谴责节目组的恶意剪辑行为，称"长期以来一直遭受不公平对待"。有艺人表示，因为恶意剪辑导致自己被网暴长达数月，承受了巨大的心理压力。</p><p>面对舆论压力，节目组于今日上午发布道歉声明，承认"在节目制作过程中存在不当行为"，并表示将对相关责任人进行处理。但公众对此道歉似乎并不买账，相关话题持续占据热搜榜。</p>',
    category: '综艺翻车',
    categorySlug: 'zongyi-fanche',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20studio%20control%20room%20with%20multiple%20monitors%20displaying%20editing%20timeline%2C%20dark%20ambient%20lighting%2C%20professional%20video%20editing%20setup%2C%20dramatic%20atmosphere%2C%20warm%20screen%20glow%2C%20cinematic%20look%2C%20no%20text%2C%20clean%20composition&width=800&height=500&seq=article-cover-003&orientation=landscape',
    author: '圈内老鬼',
    publishDate: '2026-07-06',
    viewCount: 756000,
    tags: ['综艺', '恶意剪辑', '导演组', '内讧', '道歉'],
    isHot: false,
    isTrending: true,
  },
  {
    id: 'article-4',
    title: '某知名企业家私生活混乱被爆，多名女性实名举报',
    excerpt: '近日，某知名互联网企业家被多名女性实名举报私生活混乱，涉及婚内出轨、PUA等行为。相关证据材料已在社交平台广泛传播，当事人暂未回应。',
    content: '<p>近日，某知名互联网公司的创始人兼CEO被多名女性实名举报，指控其存在长期的婚内出轨行为和PUA（情感操控）行为。举报者通过社交平台发布了大量聊天记录、照片等证据材料，引发全网轰动。</p><p>根据举报内容，该企业家利用其社会地位和财富，同时与多名女性保持不正当关系，并通过情感操控手段对她们进行精神控制。其中一位举报者表示，自己在不知情的情况下被卷入这段关系长达三年之久，得知真相后一度陷入抑郁。</p><p>更令人震惊的是，举报者称该企业家在公司内部也存在类似行为，有多名女员工也曾经或正在遭受其骚扰。目前已有至少五位女性公开发声，表示愿意配合相关部门的调查。</p><p>该企业家的公司股价在消息传出后大幅下跌，市值蒸发超过200亿元。公司董事会已紧急召开会议，但暂未对外公布任何处理决定。当事人本人也始终保持沉默，其社交媒体账号已设置为私密状态。</p>',
    category: '社会大瓜',
    categorySlug: 'shehui-dagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20glass%20office%20building%20at%20dusk%20with%20dramatic%20storm%20clouds%2C%20reflection%20on%20windows%2C%20serious%20corporate%20atmosphere%2C%20dark%20moody%20sky%2C%20cinematic%20lighting%2C%20warm%20golden%20hour%20mixed%20with%20dark%20clouds%2C%20no%20text&width=800&height=500&seq=article-cover-004&orientation=landscape',
    author: '深度扒皮',
    publishDate: '2026-07-05',
    viewCount: 2340000,
    tags: ['企业家', '私生活', '实名举报', '出轨'],
    isHot: true,
    isTrending: false,
  },
  {
    id: 'article-5',
    title: '某女星被拍到与已婚富豪同游马尔代夫，经纪人火速辟谣',
    excerpt: '有网友在马尔代夫偶遇某当红女星与一已婚富豪亲密同游，照片在社交平台疯传。经纪人火速发声明称"只是普通朋友度假"，但网友并不买账。',
    content: '<p>昨日，一位在马尔代夫度假的网友在社交平台发布了一组照片，声称在某奢华海岛度假村偶遇了当红女星XXX与一位已婚富豪亲密同游。照片中，两人穿着休闲，在海滩漫步时有说有笑，举止亲密。</p><p>据知情人透露，该富豪为某知名房地产集团的董事长，身家超过百亿，且已有家室。两人在马尔代夫入住了同一家超五星级度假村的相邻别墅，度假时间超过一周。</p><p>照片在网络上传开后，该女星的经纪人火速发布声明，称两人"只是普通朋友，恰好在同一时间选择了同一家度假村度假"，并否认存在任何不正当关系。然而，网友们对这一解释并不买账，纷纷在评论区留言"你信吗？""此地无银三百两"。</p><p>有媒体尝试联系该富豪的家人，对方以"不便回应"为由挂断了电话。目前该女星已紧急回国，取消了原定于下周的品牌代言活动。</p>',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=Tropical%20beach%20resort%20at%20sunset%20with%20palm%20trees%20silhouette%2C%20luxury%20overwater%20bungalows%2C%20golden%20warm%20light%2C%20romantic%20but%20mysterious%20atmosphere%2C%20cinematic%20wide%20shot%2C%20dramatic%20clouds%2C%20no%20people%2C%20clean%20composition&width=800&height=500&seq=article-cover-005&orientation=landscape',
    author: '吃瓜一线',
    publishDate: '2026-07-05',
    viewCount: 1560000,
    tags: ['女星', '已婚富豪', '马尔代夫', '辟谣'],
    isHot: true,
    isTrending: true,
  },
  {
    id: 'article-6',
    title: '网红情侣分手大戏：互曝黑料、财务纠纷、报警处理',
    excerpt: '一对拥有百万粉丝的网红情侣近日在社交平台上演分手大戏，双方互曝对方黑料，涉及财务纠纷、家庭暴力指控，最终闹到报警处理，引发全网围观。',
    content: '<p>近日，一对在全网拥有超过500万粉丝的网红情侣上演了一场令人瞠目结舌的分手大戏。事件的导火索是女方在社交平台发布长文，指控男方"多次出轨"并"盗刷其银行卡"。</p><p>男方随即发长文反击，声称女方"长期精神控制"，并公布了多段录音作为证据。双方的粉丝迅速站队，在评论区展开了激烈的"战争"，相关话题阅读量在24小时内突破10亿。</p><p>事态在昨日下午进一步升级。女方发布视频称遭受了男方的家庭暴力，并展示了手臂上的淤青照片。男方则否认暴力指控，并反指女方"自导自演"。当晚，警方证实接到了双方的报警，已介入调查。</p><p>业内人士表示，近年来网红情侣分手引发的网络互撕事件越来越多，背后往往涉及复杂的利益纠葛。这场分手大戏预计还将持续发酵，我们将为大家持续跟进报道。</p>',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Broken%20heart%20symbolism%20with%20cracked%20phone%20screen%20on%20dark%20surface%2C%20dramatic%20red%20and%20dark%20lighting%2C%20emotional%20tension%20atmosphere%2C%20social%20media%20icons%20scattered%2C%20cinematic%20close%20up%2C%20warm%20and%20dark%20tones%2C%20no%20text&width=800&height=500&seq=article-cover-006&orientation=landscape',
    author: '八卦早知道',
    publishDate: '2026-07-04',
    viewCount: 893000,
    tags: ['网红情侣', '分手', '黑料', '报警'],
    isHot: false,
    isTrending: true,
  },
  {
    id: 'article-7',
    title: '某选秀节目出道艺人被曝学历造假，经纪公司承认"包装过度"',
    excerpt: '某通过选秀节目出道的当红艺人近日被网友扒出学历造假，声称的某知名大学学历实际上不存在。经纪公司最终发声明承认"在包装过程中存在过度美化"，引发公众愤怒。',
    content: '<p>近日，一位通过某知名选秀节目出道、目前拥有超过800万粉丝的当红艺人，被网友扒出其声称的"XX大学音乐系学士学位"实际上并不存在。</p><p>据悉，该艺人在多个公开场合和采访中均声称自己毕业于某211重点大学的音乐系。然而，近日有该校学生在社交平台发文称，经查询学校教务系统，并未找到该艺人的任何学籍信息。</p><p>面对网友的质疑，该艺人的经纪公司最初试图否认，称"可能是系统问题"。但在舆论的持续压力下，经纪公司最终于昨日发布声明，承认"在艺人前期包装过程中存在过度美化"，并表示"深表歉意"。</p><p>然而，公众对这一解释并不满意。有媒体评论指出，学历造假不仅是对粉丝的欺骗，更是对社会诚信体系的破坏。多位教育界人士呼吁，应加强对艺人学历的审核和监管。</p>',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=Graduation%20cap%20and%20diploma%20on%20dark%20dramatic%20background%20with%20torn%20paper%20effect%2C%20spotlight%20casting%20harsh%20shadow%2C%20stage%20performance%20vibe%2C%20warm%20golden%20and%20dark%20contrast%2C%20cinematic%20lighting%2C%20no%20text&width=800&height=500&seq=article-cover-007&orientation=landscape',
    author: '学历打假办',
    publishDate: '2026-07-04',
    viewCount: 675000,
    tags: ['选秀', '学历造假', '包装过度', '道歉'],
    isHot: false,
    isTrending: false,
  },
  {
    id: 'article-8',
    title: '知名影视公司被曝偷税漏税，涉及金额高达数亿元',
    excerpt: '据税务部门消息，某知名影视制作公司因涉嫌偷税漏税被立案调查，涉及金额高达数亿元。该公司旗下多位艺人紧急发表声明撇清关系。',
    content: '<p>据国家税务总局今日发布的消息，某知名影视制作公司因涉嫌严重偷税漏税行为，已被正式立案调查。经初步查实，该公司通过虚构成本、隐瞒收入、阴阳合同等方式，偷逃税款金额高达数亿元人民币。</p><p>据了解，该公司是国内影视行业的头部企业之一，制作过多部票房超过10亿的电影作品。此次被调查的消息传出后，该公司股价在今日开盘后即跌停，市值蒸发超过50亿元。</p><p>值得注意的是，该公司旗下签约有多位一线艺人。在消息曝光后，多位艺人紧急通过工作室发表声明，强调"与该公司仅为商务合作关系"，并已"终止所有合作"。然而，有法律人士指出，如果艺人在知情的情况下配合了公司的偷税行为，同样可能承担法律责任。</p><p>税务部门表示，将继续深入调查，对涉税违法行为"零容忍"，并将依法处理相关责任人。</p>',
    category: '社会大瓜',
    categorySlug: 'shehui-dagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Serious%20government%20building%20facade%20with%20tax%20symbolism%2C%20dramatic%20overcast%20sky%2C%20financial%20documents%20scattered%2C%20dark%20moody%20atmosphere%2C%20cinematic%20wide%20shot%2C%20warm%20gray%20tones%2C%20professional%20photography%2C%20no%20text&width=800&height=500&seq=article-cover-008&orientation=landscape',
    author: '财经观察员',
    publishDate: '2026-07-03',
    viewCount: 1890000,
    tags: ['偷税漏税', '影视公司', '调查', '数亿元'],
    isHot: true,
    isTrending: false,
  },
  {
    id: 'article-9',
    title: '网红餐厅后厨卫生状况触目惊心，市场监管局连夜查封',
    excerpt: '一段曝光某网红餐厅后厨的视频在社交平台疯传，画面中蟑螂乱爬、食材过期、卫生状况触目惊心。当地市场监管局连夜行动，已对该餐厅进行查封处理。',
    content: '<p>昨日晚间，一段由前员工偷拍的某网红餐厅后厨视频在社交平台引发广泛关注。视频画面显示，该餐厅后厨卫生状况极其恶劣：蟑螂在操作台上乱爬，食材随意堆放在地上，过期调料仍在使用，工作人员徒手处理熟食而不戴手套。</p><p>该视频发布后，迅速获得了超过5000万次播放量。大量曾在该餐厅消费的网友在评论区表达了愤怒和担忧，有人表示"上个月刚去过，现在想起来就想吐"。</p><p>当地市场监管局在获悉情况后连夜行动，于今日凌晨对该餐厅进行了突击检查，确认了视频中反映的卫生问题，并当场对餐厅进行了查封处理。市场监管局表示，将对该餐厅进行严肃处理，并将加强对网红餐饮的监管力度。</p><p>该事件再次引发了公众对网红餐厅食品安全问题的关注。有消费者权益保护组织呼吁，应建立更加严格的食品安全监管机制，确保消费者的饮食安全。</p>',
    category: '社会大瓜',
    categorySlug: 'shehui-dagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20restaurant%20kitchen%20interior%20with%20dramatic%20shadows%2C%20health%20inspection%20seal%20on%20door%2C%20messy%20counter%2C%20abandoned%20cooking%20equipment%2C%20grimy%20atmosphere%2C%20cinematic%20lighting%2C%20warm%20and%20dark%20tones%2C%20no%20text&width=800&height=500&seq=article-cover-009&orientation=landscape',
    author: '食安卫士',
    publishDate: '2026-07-03',
    viewCount: 1120000,
    tags: ['网红餐厅', '卫生', '查封', '后厨'],
    isHot: false,
    isTrending: true,
  },
  {
    id: 'article-10',
    title: '某电竞选手比赛期间私联粉丝，俱乐部宣布开除处理',
    excerpt: '某知名电竞战队主力选手被曝在重要比赛期间私联女粉丝，并在酒店约会。俱乐部经过调查后发布公告，宣布对该选手进行开除处理，永不录用。',
    content: '<p>今日，某知名电竞俱乐部发布公告，宣布对其主力选手XXX进行开除处理。根据公告内容，该选手在队伍参加重要比赛期间，私自在酒店约见女粉丝，严重违反了俱乐部的管理条例和职业选手的行为准则。</p><p>据知情人士透露，该选手在与女粉丝会面后，还在社交媒体上发布了大量与该粉丝相关的私密聊天记录，被其他粉丝截图传播。俱乐部在获悉情况后立即启动了内部调查程序。</p><p>该俱乐部在公告中表示："我们对于违反职业道德和队规行为持零容忍态度。经调查确认，选手XXX的行为严重损害了俱乐部和电竞行业的形象，现决定对其予以开除处理，永不录用。"</p><p>该事件在电竞圈引发广泛讨论。有业内人士指出，随着电竞行业的职业化发展，选手的职业操守和道德规范也需要相应提高。俱乐部严格管理有助于行业的健康发展。</p>',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    coverImage: 'https://readdy.ai/api/search-image?query=Esports%20gaming%20arena%20with%20empty%20chair%20under%20spotlight%2C%20dark%20background%20with%20colorful%20LED%20lights%2C%20dramatic%20stage%20setup%2C%20gaming%20keyboard%20and%20mouse%20on%20desk%2C%20cinematic%20atmosphere%2C%20no%20text&width=800&height=500&seq=article-cover-010&orientation=landscape',
    author: '电竞八卦',
    publishDate: '2026-07-02',
    viewCount: 543000,
    tags: ['电竞', '私联粉丝', '开除', '俱乐部'],
    isHot: false,
    isTrending: false,
  },
  {
    id: 'article-11',
    title: '某歌手新专辑被指抄袭海外作品，制作人连夜删帖',
    excerpt: '某知名歌手近日发布的新专辑主打歌被乐评人指出旋律与一首海外热门歌曲高度相似。网友制作对比视频后引发热议，该专辑制作人连夜删除相关宣传帖文。',
    content: '<p>近日，某知名歌手发布的全新专辑主打歌上线后，迅速被乐评人指出其主旋律与一首三年前发布的海外热门歌曲高度相似。一位音乐制作人发微博称："副歌部分几乎是一个模子刻出来的，这不是借鉴，这是照搬。"</p><p>随后，有网友制作了两首歌的对比视频，将两段旋律并排播放，相似度令人震惊。对比视频在短短数小时内播放量突破千万，相关话题迅速登上热搜。</p><p>面对铺天盖地的质疑，该专辑的制作人连夜删除了此前发布的宣传帖文，并将社交账号设置为私密。歌手本人则通过工作室发布声明，称"创作过程中参考了多种音乐风格，但并不存在抄袭行为"。</p><p>有版权律师表示，音乐抄袭的判定需要专业机构进行鉴定，但从目前公开的对比来看，两首歌曲确实存在高度相似。如果最终被认定为抄袭，歌手和制作方可能面临版权方的巨额索赔。</p>',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20microphone%20and%20headphones%20on%20dark%20background%2C%20sheet%20music%20scattered%2C%20dramatic%20stage%20lighting%2C%20copy%20symbolism%20with%20dual%20reflection%2C%20warm%20and%20dark%20contrast%2C%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=article-cover-011&orientation=landscape',
    author: '音乐警察',
    publishDate: '2026-07-02',
    viewCount: 821000,
    tags: ['抄袭', '新专辑', '删帖', '对比视频'],
    isHot: false,
    isTrending: true,
  },
  {
    id: 'article-12',
    title: '某综艺选手后台骂人被录音曝光，节目组宣布退赛处理',
    excerpt: '一段某综艺节目参赛选手在后台大骂其他选手的录音昨日被曝光，言辞激烈、不堪入耳。节目组连夜开会后宣布该选手退赛处理，该选手发长文道歉。',
    content: '<p>昨日深夜，一段某热门音乐竞演综艺节目参赛选手在后台的录音被匿名曝光。录音中，该选手用极其激烈的言辞辱骂另外两位选手，使用大量侮辱性词汇，内容不堪入耳。</p><p>录音显示，该选手因不满评委对自己上一轮表演的评价，将怒火发泄到了同场竞技的其他选手身上，声称"他们都是靠关系的""根本不配站在这个舞台上"。</p><p>录音曝光后，节目组连夜召开紧急会议，并于今日凌晨发布公告，宣布该选手自愿退出本届比赛。节目组表示："我们对于任何不尊重他人、破坏节目氛围的行为持零容忍态度。"</p><p>该选手随后在社交平台发布长文道歉，承认"一时情绪失控说了不该说的话"，并向被冒犯的选手和观众表示歉意。然而，网友们似乎并不买账，评论区充满了批评声音。</p>',
    category: '综艺翻车',
    categorySlug: 'zongyi-fanche',
    coverImage: 'https://readdy.ai/api/search-image?query=Backstage%20dressing%20room%20with%20mirror%20lights%2C%20empty%20chair%20and%20abandoned%20costume%2C%20dramatic%20shadows%2C%20tension%20atmosphere%2C%20makeup%20mirror%20reflection%2C%20warm%20vanity%20lights%20in%20dark%20room%2C%20cinematic%20lighting%2C%20no%20text&width=800&height=500&seq=article-cover-012&orientation=landscape',
    author: '综艺探员',
    publishDate: '2026-07-01',
    viewCount: 634000,
    tags: ['综艺', '后台骂人', '录音', '退赛'],
    isHot: false,
    isTrending: false,
  },
];

export const hotArticles = articles.filter(a => a.isHot);
export const trendingArticles = articles.filter(a => a.isTrending);

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter(a => a.categorySlug === slug);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find(a => a.id === id);
}

export function getRelatedArticles(article: Article, count: number = 3): Article[] {
  return articles
    .filter(a => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, count);
}